"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportCsvButton = void 0;
const react_1 = __importStar(require("react"));
const client_1 = require("../../client");
const utils_1 = require("../../client/utils");
const table_export_csv_button_1 = require("../../../../common/table-export-csv-button");
const selectors_1 = require("../../../../store/catalogs/dashboards/selectors");
const store_1 = require("../../../../../store");
const ExportCsvButton = () => {
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const selectedProductTreeId = (0, store_1.useProductTreeId)();
    const tableFilter = (0, selectors_1.usePriorityTasksTableFilter)();
    const tableSort = (0, selectors_1.usePriorityTasksTableSort)();
    const apiFilter = (0, react_1.useMemo)(() => (0, utils_1.getPriorityTasksFilterDTO)(tableFilter), [tableFilter]);
    const apiSort = (0, react_1.useMemo)(() => (tableSort ? (0, utils_1.getPriorityTasksSortDTO)(tableSort) : []), [tableSort]);
    const { exportPriorityTasks, loading } = (0, client_1.useExportPriorityTasks)({
        catalogId: selectedCatalogId,
        productTreeId: selectedProductTreeId,
        filter: apiFilter,
        sort: apiSort,
    });
    return (react_1.default.createElement(table_export_csv_button_1.TableExportCsvButton, { onClick: exportPriorityTasks, loading: loading }));
};
exports.ExportCsvButton = ExportCsvButton;
